var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"py-2 text-center"},[_c(_vm.website ? 'a' : 'span',{tag:"component",attrs:{"href":_vm.website,"target":"_blank"}},[_c('v-img',{staticClass:"mx-auto",attrs:{"contain":"","max-height":_vm.$vuetify.application.top - 25,"max-width":"80%","src":_vm.logo}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }